import { Url } from 'next/dist/shared/lib/router/router'
import Link from 'next/link'
import React, { PropsWithChildren } from 'react'
import styled, { css } from 'styled-components'

interface WrapperProps extends React.HTMLAttributes<HTMLDivElement> {
  $isFull?: boolean
}

const Wrapper = styled.div<WrapperProps>`
  display: block;
  position: relative;
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

  &.is-active {
    background-color: rgba(0, 0, 0, 0.05);
  }

  ${(props: WrapperProps) =>
    props.$isFull &&
    css`
      width: 100%;
      height: 100%;
    `}
`
const StyledLink = styled(Link)`
  display: block;
  width: 100%;
  height: 100%;
  text-decoration: none;
  color: inherit;
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
`
interface Props {
  id?: string
  isFull?: boolean
  href?: Url
  newTab?: boolean
  className?: string
  onClick?: React.MouseEventHandler
  trackEvent?: () => void
}

const Action: React.FC<PropsWithChildren<Props>> = ({
  id,
  isFull = false,
  href,
  newTab = false,
  className,
  children,
  onClick,
  trackEvent,
}) => {
  const wrapperRef = React.createRef<HTMLDivElement>()
  const isActionRef = React.useRef(false)

  const handleClick = React.useCallback(
    (e: React.MouseEvent) => {
      if (isActionRef.current) {
        return
      }

      isActionRef.current = true
      wrapperRef.current?.classList.add('is-active')

      setTimeout(() => {
        isActionRef.current = false
        wrapperRef.current?.classList.remove('is-active')
      }, 500)

      trackEvent?.()
      onClick?.(e)
    },
    [onClick, trackEvent, isActionRef, wrapperRef],
  )

  return (
    <Wrapper id={id} ref={wrapperRef} className={className} $isFull={isFull}>
      <StyledLink
        href={href || ''}
        onClick={handleClick}
        target={newTab ? '_blank' : undefined}
        rel={newTab ? 'noopener noreferrer' : undefined}
      >
        {children}
      </StyledLink>
    </Wrapper>
  )
}

export default Action
